import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { MessageService, PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService]
})
export class AppComponent implements OnInit {

  reseauxSociaux = [
    {
      icon: 'fab fa-linkedin',
      url: "https://www.linkedin.com/company/ferme-ma-zado%C3%B9"
    },{
      icon: 'fab fa-twitter',
      url: "https://twitter.com/Ferme_Ma_Zadou"
    },{
      icon: 'fab fa-instagram',
      url: "https://www.instagram.com/ferme_ma_zadou/"
    },{
      icon: 'fab fa-facebook',
      url: "https://www.facebook.com/profile.php?id=100089032676679"
    }
  ];

  partners = [
    {
      url: "https://owc.ifoam.bio/2021/fr ",
      name: "Congrès Mondial de la Bio",
      icon: "assets/images/voyage_en_terre_bio.jpg"
    },{
      url: "https://www.ancv.com/le-cheque-vacances",
      name: "ANCV",
      icon: "assets/images/logo_ancv.png"
    },{
      url: "https://www.accueil-paysan.com/fr/catalog/structure/2188/",
      name: "Accueil-paysan",
      icon: "assets/images/logo_AP.png"
    }
  ]
  showMenuLang = false;

  email = "contact@fermemazadou.bzh";
  phone = "0033 (0)6 31 30 93 80";

  langues = [
    {locale: "fr", image: "assets/icons/France.svg", title: "common.lang.fr"}
  ];

  current_lang = {locale: "fr", image: "assets/icons/France.svg", title: "common.lang.fr"}

  current_year = new Date().getFullYear();

  constructor(
    private i18n: TranslateService,
    private clipboardService: ClipboardService,
    private messageService: MessageService
  ) {
    let locale = localStorage.getItem('locale');
    if(locale === undefined || locale === null) {
      locale = 'fr';
    } else {
      locale = locale.toLocaleLowerCase()
    }
    this.i18n.setDefaultLang(locale)
  }

  ngOnInit() {
  }

  changeLang(locale: String) {
    const lang = this.langues.find(l => l.locale === locale);
    if(lang !== undefined) {
      this.i18n.setDefaultLang(lang.locale);
      localStorage.setItem('locale', lang.locale);
      this.current_lang = lang;
    }
  }

  clickToClipboard(email: boolean) {
    if (email) {
      this.clipboardService.copyFromContent(this.email);
    } else {
      this.clipboardService.copyFromContent(this.phone);
    }

    this.messageService.add({severity:'success', summary:this.i18n.instant('common.copied-clipboard')});
  }

}
